<template>
  <a
    ref="caseItem"
    :href="cases.link ? cases.link : `cases/${cases.id}`"
    :class="[
      $style.caseItem,
      { [$style.caseItemFiltered]: filtered },
      { [$style.caseItemBig]: isBigImageShow },
      { [$style[`${cases.size}`]]: isBigImageShow },
    ]"
    target="_blank"
  >
    <div :class="$style.info">
      <img :src="imageSrc(cases.id)" :class="$style.img" alt="Изображение" />
      <img
        v-if="cases.size"
        :src="imageSrc(cases.id + '-big')"
        :class="[$style.img, $style.imgBig]"
        alt="Изображение"
      />
      <ul :class="$style.category">
        <li
          v-for="(industry, index) in cases.industries"
          :key="index"
          :value="industry"
          @click.prevent="chooseIndustry(industry)"
        >
          {{ industry.title }}
        </li>
      </ul>
      <h3 :class="$style.title" v-html="cases.title"></h3>
    </div>
    <span :class="$style.button">Читать кейс</span>
  </a>
</template>
<script>
export default {
  name: 'CaseItem',
  props: {
    filtered: {
      type: Boolean,
      default: false,
    },
    cases: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      itemsToShow: 10,
      imagePath: 'static/promo-static/landing-2021/src/images/blocks/customer-cases/customers/',
    };
  },
  computed: {
    isBigImageShow(cases) {
      return this.cases.size && !this.filtered;
    },
  },
  methods: {
    imageSrc(id) {
      return `${this.imagePath}${id}.svg`;
    },
    chooseIndustry(industry) {
      this.$emit('chooseIndustry', industry);
    },
  },
};
</script>

<style module lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;

.caseItem {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: space-between;
  color: vars.$colorBase;
  transition: unset;

  @include mixins.hover {
    &:hover {
      filter: saturate(1.25);

      .button {
        background-color: rgba(235, 237, 242, 1);
      }
    }
  }

  @include mixins.media(sm, max) {
    &:not(:last-child) {
      margin-bottom: 6rem;
    }
  }

  .img {
    max-width: 100%;
    border-radius: 12px;

    @include mixins.media(xl) {
      border-radius: 16px;
    }

    &Big {
      display: none;
    }
  }

  .category {
    display: flex;
    margin: 10px 0 0 4px;

    li {
      @include mixins.font(1.1rem, 1);

      position: relative;
      margin-top: 6px;
      font-weight: vars.$fontWeightMedium;
      letter-spacing: 0.1em;
      opacity: 0.6;
      text-transform: uppercase;
      white-space: nowrap;

      @include mixins.hover {
        &:hover {
          color: #534bc3;
          opacity: 1;
        }
      }

      &:not(:first-child) {
        margin-left: 12px;

        &::after {
          font-weight: vars.$fontWeightSolid;
          position: absolute;
          top: 0;
          left: -10px;
          content: '\/';
        }
      }
    }
  }

  .title {
    @include mixins.font(1.8rem, 1.45);

    padding-right: 10px;
    margin: 8px 0 0 4px;
    font-weight: vars.$fontWeightBase;
    letter-spacing: -0.005em;

    @include mixins.media(xl) {
      padding-right: 20px;
    }
  }

  .button {
    @include mixins.font(1.6rem, 1.55);

    padding: 4px 12px;
    margin-top: 12px;
    background-color: rgba(235, 237, 242, 0.6);
    border-radius: 32px;
    transition: 0.3s ease;

    @include mixins.media(md) {
      margin-top: 16px;
    }
  }

  &:nth-child(1),
  &:nth-child(5) {
    justify-content: initial;
  }

  &Filtered {
    &:nth-child(1),
    &:nth-child(5) {
      justify-content: space-between;
    }
  }

  @include mixins.media(lg) {
    &Big {
      height: 408px;
      justify-content: end;
      padding: 36px;

      @include mixins.hover {
        &:hover {
          .button {
            background-color: rgba(255, 255, 255, 1);
          }
        }
      }

      @include mixins.media(xl) {
        height: 482px;
      }

      .info {
        max-width: 300px;

        @include mixins.media(xl) {
          max-width: 350px;
        }
      }

      .category {
        margin: 6px 0 0 0;
      }

      .title {
        @include mixins.font(2.8rem, 1.28);

        padding-right: initial;
        margin-left: initial;
        letter-spacing: -0.02em;

        @include mixins.media(md) {
          @include mixins.font(2.2rem, 1.28);
        }

        @include mixins.media(xl) {
          @include mixins.font(2.8rem, 1.28);
        }
      }

      .img {
        display: none;
      }

      .imgBig {
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        display: block;
      }

      .button {
        background-color: rgba(255, 255, 255, 0.6);
      }
    }
  }
}

.big-1 {
  @include mixins.media(lg) {
    grid-row: 1 / span 1;
    grid-column: 1 / span 2;
  }
}

.big-2 {
  @include mixins.media(lg) {
    grid-row: 3 / span 1;
    grid-column: 2 / span 2;
  }
}
</style>
